import clsx from 'clsx'

type Props = {
  achieved: number
  total: number
  className?: string
  compact?: boolean
}

/** Fração de marcos conquistados — rail direito, acima da recompensa. */
export const LadderMilestoneBadge = ({
  achieved,
  total,
  className,
  compact = false
}: Props) => {
  if (total <= 0) return null

  const completed = achieved >= total

  return (
    <div
      className={clsx(
        'inline-flex w-full items-center justify-center rounded-md border',
        'font-bold tabular-nums leading-none',
        compact ? 'px-2.5 py-1 text-2xs' : 'px-3 py-1.5 text-xs',
        completed
          ? 'border-status-success bg-[#dcfce7] text-green-800'
          : 'border-status-success/80 bg-[#ecfdf3] text-green-800',
        className
      )}
      aria-label={`${achieved} de ${total} marcos conquistados`}
    >
      {achieved}/{total}
    </div>
  )
}
